import { resetStateToDefault, vuexMapDefaultsMutations, formatDateToSend } from 'src/utils'
import moment from 'moment'
import { API } from 'src/services'

const clearInput = (item) => item ? item.replace('.', '').replace('-', '').replace('/', '') : item

function fromBackend (employee) {
  // returns a object that we can use in Object.assign to update all state once

  function customFieldsFormater ({key, value}) {
    return {
      field: key,
      text: value
    }
  }

  return {
    name: employee.name,
    code: employee.code,
    phoneclockPassword: employee.phoneclockPassword,
    closingDate: employee.closingDate,
    company: employee.company[0],
    employer: employee.employer[0],
    customRules: employee.customRules,
    whbRules: employee.workHourBankRules,
    admission: moment(employee.admission).toDate(),
    email: employee.email,
    cellPhone: clearInput(employee.cellPhone),
    phone: clearInput(employee.phone),
    ctps: clearInput(employee.ctps),
    pis: clearInput(employee.pis),
    routineInfo: {
      phaseShift: employee.routinePhaseShift,
      initialDay: moment(employee.initialDay).toDate(),
      routine: employee.routine
    },
    rg: clearInput(employee.rg),
    cpf: clearInput(employee.cpf),
    department: employee.department,
    funct: employee.funct,
    hasVr: employee.hasVt,
    hasVt: employee.hasVt,
    customFields: employee.customFields.map(customFieldsFormater),
    customFieldsFolha: employee.customFieldsFolha.map(customFieldsFormater),
    allowAppVoice: employee.allowAppVoice,
    allowAppPhoto: employee.allowAppPhoto,
    allowAppShowDayJourney: employee.allowAppShowDayJourney,
    allowAppFeedback: employee.allowAppFeedback,
    canSelectCompany: employee.canSelectCompany,
    recognizeFace: employee.recognizeFace,
    allowWebVoice: employee.allowWebVoice,
    doubleCheckWeb: employee.doubleCheckWeb,
    allowPunchSerial: employee.allowPunchSerial,
    hasOnCall: employee.hasOnCall,
    phoneclockAll: employee.phoneclockAll,
    autoPauseFill: employee.autoPauseFill
  }
}

function toBackEnd (state) {
  function customFieldsFormater ({field, text}) {
    return {
      key: field,
      value: text
    }
  }

  function workRules (selected) {
    if (selected?.id && selected.id !== 'none') {
      return selected.id
    }
    return {id: 'none', name: 'Sem Regra de Banco de Horas'}
  }

  return {
    name: state.name,
    code: String(state.code),
    phoneclockPassword: String(state.phoneclockPassword),
    closingDate: state.closingDate,
    company: [{id: state.company.selected.id}],
    employer: [{id: state.employer.selected.id}],
    customRules: {
      id: state.customRules.selected.id
    },
    workHourBankRules: workRules(state.whbRules.selected),
    admission: formatDateToSend(state.admission),
    email: state.email,
    cellPhone: clearInput(state.cellPhone),
    phone: clearInput(state.phone),
    ctps: clearInput(state.ctps),
    pis: clearInput(state.pis),
    routinePhaseShift: state.routineInfo.phaseShift,
    initialDay: formatDateToSend(state.routineInfo.initialDay),
    routine: {id: state.routineInfo.routine.id},
    rg: clearInput(state.rg),
    cpf: clearInput(state.cpf),
    department: state.department,
    funct: state.funct,
    hasVr: state.hasVt,
    hasVt: state.hasVt,
    customFields: state.customFields.map(customFieldsFormater),
    customFieldsFolha: state.customFieldsFolha.map(customFieldsFormater),
    allowAppVoice: state.allowAppVoice,
    allowAppPhoto: state.allowAppPhoto,
    allowAppShowDayJourney: state.allowAppShowDayJourney,
    allowAppFeedback: state.allowAppFeedback,
    canSelectCompany: state.canSelectCompany,
    recognizeFace: state.recognizeFace,
    allowWebVoice: state.allowWebVoice,
    doubleCheckWeb: state.doubleCheckWeb,
    allowPunchSerial: state.allowPunchSerial,
    hasOnCall: state.hasOnCall,
    phoneclockAll: state.phoneclockAll,
    autoPauseFill: state.autoPauseFill
  }
}

function defaultState () {
  return {
    id: null,
    loading: false,
    name: '',
    code: '',
    phoneclockPassword: '',
    closingDate: 1,
    company: {
      selected: null
    },
    employer: {
      selected: null,
      loaded: []
    },
    customRules: {
      selected: null,
      loaded: []
    },
    whbRules: {
      selected: null,
      loaded: []
    },
    admission: null,
    email: '',
    cellPhone: '',
    phone: '',
    ctps: '',
    pis: '',
    routineInfo: {
      phaseShift: 0,
      initialDay: null,
      routine: null
    },
    rg: '',
    cpf: '',
    department: '',
    funct: '',
    hasVr: false,
    hasVt: false,
    customFields: [],
    customFieldsFolha: [],
    allowAppVoice: false,
    allowAppPhoto: false,
    allowAppShowDayJourney: false,
    allowAppFeedback: false,
    canSelectCompany: false,
    recognizeFace: false,
    allowWebVoice: false,
    doubleCheckWeb: false,
    allowPunchSerial: false,
    hasOnCall: false,
    phoneclockAll: false,
    autoPauseFill: false
  }
}
const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  setFromState (state, {company, employer, customRules, whbRules, ...employee}) {
    state.company.selected = company
    state.employer.selected = employer
    state.customRules.selected = customRules
    state.whbRules.selected = whbRules

    delete employee.company
    delete employee.employer
    delete employee.customRules
    delete employee.whbRules
    Object.assign(state, employee)
  },
  changeChecksTimelogs (state, {field, value}) {
    state[field] = Boolean(value)
  },
  loading (state, payload) {
    state.loading = payload
  }
}

const actions = {
  async loadEmployee ({ commit }, employeeId) {
    commit('loading', true)

    const api = await API.employee.get({id: employeeId, active: false, fired: 'all'})

    const info = api.data.success[0]

    if (info.cellPhone && info.cellPhone.startsWith('55')) {
      info.cellPhone = info.cellPhone.substring(2)
    }
    if (info.phone && info.phone.startsWith('55')) {
      info.phone = info.phone.substring(2)
    }

    commit('setFromState', {id: employeeId, ...fromBackend(info)})

    commit('loading', false)
  },
  async save ({ state }) {
    const info = toBackEnd(state)
    if (info.cellPhone) info.cellPhone = '55'.concat(info.cellPhone.replace(/[^\d]+/g, ''))
    if (info.phone) info.phone = '55'.concat(info.phone.replace(/[^\d]+/g, ''))
    if (state.id) {
      await API.employee.save({id: state.id}, info)
    } else {
      await API.employee.save(info)
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations,
  actions
}
